<template>
  <div>
    <b-card>
      <b-row>
        <b-col md="3">
          <b-form-group label="Filtrer par magasin">
            <v-select
                v-model="selectedStock"
                :clearable="false"
                :options="stockOptions"
                label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Type d'opération">
            <b-form-select
                v-model="operationType"
                :options="operationTypeOptions"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Période du">
            <flat-pickr
                id="from"
                v-model="fromDateRange"
                :config="datePickerConfig"
                class="form-control"
                placeholder="Du"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Au">
            <flat-pickr
                id="from"
                v-model="toDateRange"
                :config="datePickerConfig"
                class="form-control"
                placeholder="Au"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-row class="mt-2">
      <b-col md="6">
        <b-card>
          <b-card-title>
            <span>Liste des opérations</span>
          </b-card-title>
          <b-card-sub-title>
            <label class="mr-1">Affichage</label>
            <v-select
                v-model="perPage"
                :clearable="false"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                class="per-page-selector d-inline-block mb-2"
            />

          </b-card-sub-title>
          <b-table
              :fields="tableFields"
              :items="operations"
              hover
              responsive="sm"
              @row-clicked="selectOperation"
          >
            <template #cell(date)="data">
              {{ formatDate(data.item.created_at) }}
            </template>
          </b-table>

          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                  class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  cols="12"
                  sm="6"
              >
            <span class="text-muted"
            >{{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} Opérations</span
            >
              </b-col>
              <!-- Pagination -->
              <b-col
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  cols="12"
                  sm="6"
              >
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalOperations"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18"/>
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18"/>
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-spinner v-if="isLoading"/>
        <b-card
            v-else-if="!isLoading && selectedOperation"
            :title="`Détail de l'opération #${selectedOperation.code}`"
        >
          <div v-if="operationType === 'out'">
            <b-list-group>
              <b-list-group-item v-for="item in selectedOperation.releases_history" :key="item.uid">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ item.product }}</strong><br>
                    Quantité: {{ item.qty }}
                  </div>
                  <div>
                    <b-badge variant="light-primary">
                      {{ item.stock }}
                    </b-badge>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>

            <div class="mt-2">
              <b-button variant="primary" @click="returnProductsToStore">
                <feather-icon class="mr-50" icon="RotateCcwIcon"/>
                <span>Retourner les produits au magasin</span>
              </b-button>
            </div>
          </div>
          <div v-else>
            <b-list-group>
              <b-list-group-item v-for="item in selectedOperation.supplies_history" :key="item.uid">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ item.product }}</strong><br>
                    Quantité: {{ item.qty }} / Disponible: {{ item.qty + item.last_available_qty }}
                  </div>
                  <div>
                    <b-badge variant="light-primary">
                      {{ item.condition.toUpperCase() }}
                    </b-badge>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>
          </div>
        </b-card>
        <b-card v-else>
          <p class="text-muted text-center">
            Sélectionnez une opération pour voir les détails
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCardSubTitle,
  BCardTitle,
  BCol,
  BFormGroup,
  BFormSelect,
  BListGroup,
  BListGroupItem,
  BPagination,
  BRow,
  BSpinner,
  BTable,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import {onMounted} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import {useStoreHistory} from "@/views/apps/stock-store/stock-store-details/history/useStoreHistory";
import flatPickr from "vue-flatpickr-component";
import {formatDate} from "@core/utils/filter";

export default {
  methods: {formatDate},
  components: {
    BPagination,
    BCardSubTitle,
    BCardTitle,
    BSpinner,
    BCard,
    BRow,
    BCol,
    BTable,
    BFormGroup,
    BFormSelect,
    BBadge,
    BListGroup,
    BListGroupItem,
    BButton,
    VSelect,
    flatPickr,
  },
  setup() {
    const {
      isLoading,
      tableFields,
      stockOptions,
      operationType,
      operationTypeOptions,
      selectedStock,
      selectedOperation,
      fromDateRange,
      toDateRange,
      datePickerConfig,
      perPage,
      perPageOptions,
      dataMeta,
      totalOperations,
      currentPage,

      selectOperation,
      fetchStocksList,
      fetchOperationsHistory,

      operations,
    } = useStoreHistory()

    onMounted(() => {
      fetchStocksList()
      fetchOperationsHistory()
    })

    // Filter operations
    // const filteredOperations = computed(() => {
    //   let result = [...operations.value]
    //
    //   if (operationType.value) {
    //     result = result.filter(op => op.type === operationType.value)
    //   }
    //
    //   if (selectedStore.value) {
    //     result = result.filter(op => op.storeId === selectedStore.value.id)
    //   }
    //
    //   if (dateRange.value) {
    //     const [startDate, endDate] = dateRange.value.split(' to ')
    //     if (startDate && endDate) {
    //       result = result.filter(op => {
    //         const opDate = moment(op.date).format('YYYY-MM-DD')
    //         return moment(opDate).isBetween(startDate, endDate, null, '[]')
    //       })
    //     }
    //   }
    //
    //   return result
    // })


    // Return products to store
    const returnProductsToStore = () => {
      if (!selectedOperation.value || selectedOperation.value.type !== 'out') return

      // Here you'll implement the logic to return products to store
      // This could be a modal confirmation and API call
      // For now, just show a toast
      store.dispatch('app/showToast', {
        component: ToastificationContent,
        props: {
          title: 'Retour de produits',
          text: 'Fonctionnalité en cours de développement',
          icon: 'InfoIcon',
          variant: 'info',
        },
      })
    }

    return {
      isLoading,
      operations,
      selectedOperation,
      selectedStock,
      stockOptions,
      operationType,
      operationTypeOptions,
      fromDateRange,
      toDateRange,
      datePickerConfig,
      perPage,
      perPageOptions,
      currentPage,
      tableFields,
      dataMeta,
      totalOperations,
      selectOperation,
      returnProductsToStore,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>